import styled, { keyframes, css } from 'styled-components';
import {
	neutralWhite, actionBlueDark, whiteAlpha30,
	dangerLightAlpha, successLightAlpha, dangerLight, successLight,
} from '../themes/colors';
import { Button, ButtonVariant } from '../button';

const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const fadeOut = keyframes`
	from {
		opacity: 1;
		transform: translateY(0);
	}
	to {
		opacity: 0;
		transform: translateY(30px);
	}
`;

export const ActionBarWrapper = styled.div`
	position: fixed;
	bottom: 20px;
	left: 50%;
	transform: translateX(-50%);
	min-width: 300px;
	max-width: 700px;
	z-index: 1000;
`;

export const ActionBarAnimationWrapper = styled.div<{ $isExiting?: boolean }>`
	background: ${actionBlueDark};
	border-radius: 30px;
	padding: 16px 24px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	box-shadow: 0px 4px 30px 6px rgba(32, 56, 87, 0.40);
	animation: ${fadeIn} 0.3s cubic-bezier(0.4,0,0.2,1);
	${({ $isExiting }) => $isExiting && css`
		animation: ${fadeOut} 0.3s cubic-bezier(0.4,0,0.2,1) forwards;
	`}
`;

export const ActionBarContent = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const ContentWrap = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 4px;
`;

export const Divider = styled.div`
	height: 15px;
	width: 4px;
	background: ${whiteAlpha30};
	border-radius: 3px;
	margin-left: 12px;
	margin-right: 12px;
	display: inline-block;
`;

export const Text = styled.p`
	color: ${neutralWhite};
	font-size: 14px;
	margin: 0;
`;

export const CloseButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	color: ${neutralWhite};
	display: flex;
	align-items: center;
`;

export const StyledButton = styled(Button)<{ $variant: ButtonVariant }>`
	variant: ${({ $variant }) => $variant};
	border-radius: 4px;
	background: transparent;
	color: ${neutralWhite};
	border: none;
	&:hover {
		background: ${({ $variant }) => $variant === 'danger' ? dangerLightAlpha : successLightAlpha};
		color: ${({ $variant }) => $variant === 'danger' ? dangerLight : successLight};
		border: none;
		.icon {
			color: ${({ $variant }) => $variant === 'danger' ? dangerLight : successLight};
		}
	}
	.icon {
			color: ${neutralWhite};
	}
`;
